import { TProduct } from 'types/product';
import { TTopicMessageStats } from './topicMessages';

type TOrderProduct = {
    id: number;
    workId: number;
    name: string;
    price: number;
    quantity: number;
    min_performers: number;
    total: number;
    type: string;
    assigned_performers_count: number;
    assigned_performers: Array<{
        id: number;
        user: {
            id: number;
            surname: string;
            name: string;
            patronymic: string;
        };
        picture: {
            original: string;
            compressed: string;
        };
    }>;
    /**
     * Сводка по чату заказа для позиции — приходит вместе с ней из
     * `works[].workable.data`. Нет у удалённых строк и у «Работы с товарами».
     */
    messages_count?: TTopicMessageStats['messages_count'];
    last_message?: TTopicMessageStats['last_message'];
};

const normalizeOrderProduct = (product: TProduct, quantity: number): TOrderProduct => {
    return {
        id: product.id,
        name: product.name,
        quantity: quantity,
        price: product.price,
        total: product.price * quantity,
    };
};

export { TOrderProduct, normalizeOrderProduct };
